export const useGoogleZoomControl = (map: Ref<google.maps.Map | undefined>, mainAsset: Ref<LookupAsset | undefined>) => {
  const currentZoom = ref(0)

  const changeZoom = (zoom: number) => {
    if (!map.value) {
      return
    }

    const currentZoom = map.value.getZoom() ?? 0

    map.value.setZoom(currentZoom + zoom)
  }

  const zoomOnCluster = (cluster: GeoCluster) => {
    if (!map.value) {
      return
    }

    map.value.setZoom(14)
    map.value.panTo({ lng: cluster.center[0], lat: cluster.center[1] })
  }

  const initializeZoomControl = () => {
    if (!map.value) {
      throw new Error("Map is not initialized")
    }

    map.value.addListener("zoom_changed", () => (currentZoom.value = map.value?.getZoom() ?? 0))
  }

  const clusterCutoffLimit = computed(() => (mainAsset.value ? 0 : 14))

  return {
    currentZoom,

    zoomOnCluster,
    changeZoom,
    initializeZoomControl,

    clusterCutoffLimit,
  }
}
